export enum FaqSubject {
  ServiceProfileCreation,
  ServiceAvailabilitySlots,
  ServiceJobs2Live,
  EnterpriseAdminProfileCreation,
  EnterpriseUserProfileCreation,
  EnterpriseProjectAndServiceRequests,
  EnterpriseJobs2Live
}

export interface FaqData {
  modalTitle: string;
  tabTitle: string;
  items: { title: string; text: string; order: number }[];
  order: number;
}

export enum FaqPageType {
  Person,
  EnterpriseUser
}
